function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 16.25C16.2949 16.25 17.75 14.7949 17.75 13C17.75 11.2051 16.2949 9.75 14.5 9.75C12.7051 9.75 11.25 11.2051 11.25 13C11.25 14.7949 12.7051 16.25 14.5 16.25ZM24.75 13.75C24.75 15.1307 23.6307 16.25 22.25 16.25C20.8693 16.25 19.75 15.1307 19.75 13.75C19.75 12.3693 20.8693 11.25 22.25 11.25C23.6307 11.25 24.75 12.3693 24.75 13.75ZM16.75 21.75C16.75 20.0455 17.5253 18.5221 18.7426 17.5133C18.4501 17.3458 18.1112 17.25 17.75 17.25H11.25C10.1454 17.25 9.25 18.1454 9.25 19.25C9.25 19.25 9.25 23.25 14.5 23.25C15.4528 23.25 16.2326 23.1183 16.871 22.9026C16.7917 22.5309 16.75 22.1453 16.75 21.75ZM26.75 21.75C26.75 24.2353 24.7353 26.25 22.25 26.25C19.7647 26.25 17.75 24.2353 17.75 21.75C17.75 19.2647 19.7647 17.25 22.25 17.25C24.7353 17.25 26.75 19.2647 26.75 21.75ZM22.75 19.75C22.75 19.4739 22.5261 19.25 22.25 19.25C21.9739 19.25 21.75 19.4739 21.75 19.75V21.25H20.25C19.9739 21.25 19.75 21.4739 19.75 21.75C19.75 22.0261 19.9739 22.25 20.25 22.25H21.75V23.75C21.75 24.0261 21.9739 24.25 22.25 24.25C22.5261 24.25 22.75 24.0261 22.75 23.75V22.25H24.25C24.5261 22.25 24.75 22.0261 24.75 21.75C24.75 21.4739 24.5261 21.25 24.25 21.25H22.75V19.75Z",
  fill: "#AA50E2"
});

function SvgPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple);
export default __webpack_public_path__ + "static/media/purple.e79fae94.svg";
export { ForwardRef as ReactComponent };